import { BaseModel } from '../core/abstractions/base.model';
import { GridStoredConfig } from './core/grid-stored.config';
import { DictionaryType } from './types/dictionary.type';

export class GridsSettingsModel extends BaseModel {
    grids: DictionaryType<GridStoredConfig> = {};

    constructor(init?: Partial<GridsSettingsModel>) {
        super();
        Object.assign(this, init);
    }

    setGridConfig(name: string, config: GridStoredConfig): void {
        this.grids[name] = config;
    }
}
